import styled from '@eduzz/houston-styles/styled';

export const ToolbarContainer = styled.div`
  background: ${({ theme }) => theme.neutralColor.high.pure};
  padding: ${({ theme }) => `${theme.spacing.inline.nano} ${theme.spacing.inline.nano} ${theme.spacing.inline.xxxs}`};
  border-bottom: ${({ theme }) => `${theme.border.width.xs} solid rgba(0, 0, 0, ${theme.opacity.level['3']})`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: ${({ theme }) => `${theme.pxToRem(48)}rem`};

  & a {
    width: 50px;
    display: flex;
  }

  & a svg {
    width: 100%;
  }
`;

export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.nano};
`;
